import { getCookie } from '../dbconnector/checktoken'



//server https


// const baseurl = "https://myshc.net:9000/api"
// const baseUrlNonApi = "https://myshc.net:9000/"


// // //monkiis apiserver
// const baseurl = "https://shc.monkiis.be:80/api"
// const baseUrlNonApi = "https://shc.monkiis.be:80/"
// const baseUrlfilestorage = "https://shc.monkiis.be:80/"

// // sam-assist.com
const baseurl = "https://sam-assist.com:9000/api"
const baseUrlNonApi = "https://sam-assist.com:9000/"
const baseUrlfilestorage = "https://sam-assist.com:9000/"


// michielpc
// const baseurl = "http://192.168.129.5:9000/api"
// const baseUrlNonApi = "http://192.168.129.5:9000/"
// const baseUrlfilestorage = "http://192.168.129.5:9000/"

//pc tom
// const baseurl = "http://192.168.129.42:9000/api"
// const baseUrlNonApi = "http://192.168.129.42:9000/"
// const baseUrlfilestorage = "http://192.168.129.42:9000/"




const formatdates = (object) => {
  for (const key in object) {
    if (key.includes("datum") || key.includes("date") || typeof object[key] === "date") {
      if (object[key] !== null) {
        object[key] = new Date(object[key]).toLocaleDateString("en-CA")
      }
    }
  }
  return object
}
const getserverurl = () => {
  return baseUrlNonApi
}
const getfilestoragelocation = () => {
  return baseUrlfilestorage
}

// create - edit - update - get Hotel

const sendhoteldata = async (form) => {
  //////////////console.log(form);
  const Bearer = await getCookie("logintoken")
  const formdata = new FormData();
  formdata.append("file", form.Contract.value)
  if (form.Contract.value.length === 0) {
    return await fetch(baseurl + "/hotels/createhotel", {
      method: "POST",
      body: JSON.stringify({
        ...form
      }),
      headers: {
        "Content-type": "application/json",
        "Token": "Bearer " + Bearer,
      }
    });
  } else {
    const fileresponse = await fetch(baseurl + "/hotels/upload", {
      method: "POST",
      body: formdata,
    }).then(response => response.json()).then(result => {
      return result
    });
    const filename = fileresponse.filename;
    return await fetch(baseurl + "/hotels/createhotel", {
      method: "POST",
      body: JSON.stringify({
        ...form,
        Contract: filename
      }),
      headers: {
        "Content-type": "application/json",
        "Token": "Bearer " + Bearer,
      }
    });
  }
}
const savefocusoftheday = async (hotelid, message) => {
  console.log(hotelid, message)
  const Bearer = await getCookie("logintoken")
  const fileresponse = await fetch(baseurl + "/hotels/createfocusoftheday/" + hotelid + "/" + message, {
    method: "POST",
    body: JSON.stringify({
      hotel_id: hotelid,
      description: message
    }),
  }).then(response => response.json()).then(result => {
    return result
  });
}
const updateHotelData = async (form, hotelid) => {
  const Bearer = await getCookie("logintoken")
  let response;
  if (form.Contract && form.Contract !== null && form.Contract.value) {
    const formdata = new FormData();
    formdata.append("file", form.Contract.value)
    const fileresponse = await fetch(baseurl + "/hotels/upload", {
      method: "POST",
      body: formdata,
    }).then(response => response.json()).then(result => {
      return result
    });
    const filename = fileresponse.filename;
    response = await fetch(baseurl + "/hotels/updatehotel/" + hotelid, {
      method: "POST",
      body: JSON.stringify({
        ...form,
        Contract: filename
      }),
      headers: {
        "Content-type": "application/json",
        "Token": "Bearer " + Bearer,
      }
    });
  } else {
    response = await fetch(baseurl + "/hotels/updatehotel/" + hotelid, {
      method: "POST",
      body: JSON.stringify({
        ...form
      }),
      headers: {
        "Content-type": "application/json",
        "Token": "Bearer " + Bearer,
      }
    });
  }
  return response
}

const getallhotels = async (active) => {
  const Bearer = await getCookie("logintoken")

  const hotel = await fetch(baseurl + "/hotels/" + active, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => response.json()).then(result => {
    return result
  })
  return hotel;
}
const getallstatushotels = async () => {
  const Bearer = await getCookie("logintoken")

  const hotel = await fetch(baseurl + "/hotels/allstatus", {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => response.json()).then(result => {
    return result
  })
  return hotel;
}

const gethotel = async (id) => {
  //console.log("hotelid= ", id)
  const Bearer = await getCookie("logintoken")
  const hotel = await fetch(baseurl + "/hotels/gethotel/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => { return response.json() })
  return hotel;
}

const gethotelcleaners = async (id, active) => {
  const Bearer = await getCookie("logintoken")
  const employee = await fetch(baseurl + "/employee/gethotelcleaners/" + id + "/" + active, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  })
  return employee;
}

const gethistoricalhotelcleaners = async (id) => {
  const Bearer = await getCookie("logintoken")
  const employee = await fetch(baseurl + "/employee/gethistoricalhotelcleaners/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  })
  return employee;
}

// end function 'Hotel'


// load a pdf
const getcontract = (pdfname) => {
  return baseUrlNonApi + pdfname;
}


// create - edit - update - get Employee data
const saveLinkedhotels = async (linkedhotels, id, h24) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/employee/savehotels/" + id, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    },
    body: JSON.stringify({
      linkedhotels,
      h24
    })
  })
}

const getLinkedhotels = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/employee/getlinkedhotels/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    },
  })
}
//isNightshift
const isNightshift = async (employee_id, hotel_id, date = null) => {
  if (date === null) {
    date = new Date().toLocaleDateString("en-CA")
  }
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/rooster/isnightsift/" + date + "/" + employee_id + "/" + hotel_id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    },
  })
}
///getlinkedhotelscoords/:id/:longtitude/:latitude

const getLinkedhotelscoords = async (id, longitude, latitude) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/employee/getlinkedhotelscoords/" + id + "/" + longitude + "/" + latitude, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    },
  })
}

const getMyLinkedhotels = async (date = null) => {
  //////////console.log("getMyLinkedhotels date = ", date)
  if (date === null) {
    date = new Date().toLocaleDateString("en-CA")
  }

  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/employee/getmylinkedhotels/" + date, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    },
  })
}

const getAllhotelsForAdministrator = async (date = null) => {
  if (date === null) {
    date = new Date().toLocaleDateString("en-CA")
  }

  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/employee/getallhotelsforadministrator/" + date, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    },
  })
}

const sendemployeedata = async (user) => {
  user = formatdates(user);
  console.log("userdata =" , user)
  const Bearer = await getCookie("logintoken")
  const response = await fetch(baseurl + "/employee/create", {
    method: "POST",
    body: JSON.stringify({
      ...user
    }),
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,

    }
  });
  return response;

}

const updateEmployeedata = async (user) => {
  user = formatdates(user);
  const Bearer = await getCookie("logintoken")
  const response = await fetch(baseurl + "/employee/" + user.id, {
    method: "put",
    body: JSON.stringify({
      ...user
    }),
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
  return response

}

const getemployees = async (status = null) => {
  // let l_status = true
  // if (status !== null) {
  //   l_status = status
  // }
  //console.log("status" , status)
  const Bearer = await getCookie("logintoken")
  const employee = await fetch(baseurl + "/employee/" + status, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => response.json())
  return employee;
}

const deleteEmployee = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/employee/" + id, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
}

//end functions 'Employee'

//start functions for employers
const createEmployer = async (employer) => {
  const Bearer = await getCookie("logintoken")
  const response = await fetch(baseurl + "/employer/create/", {
    method: "put",
    body: JSON.stringify({
      ...employer
    }),
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => response.json())
  return response;
}

const UpdateEmployer = async (employer, id) => {
  const Bearer = await getCookie("logintoken")
  const response = await fetch(baseurl + "/employer/update/" + id, {
    method: "put",
    body: JSON.stringify({
      ...employer
    }),
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
  return response
}

const getEmployer = async (id = null) => {
  //console.log("id", baseurl + "/employer/getemployer/" + id)
  const Bearer = await getCookie("logintoken")
  const employer = await fetch(baseurl + "/employer/getemployer/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => response.json())
  return employer;
}


const getemployers = async (status = null) => {
  const Bearer = await getCookie("logintoken")
  const employers = await fetch(baseurl + "/employer/" + status, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => response.json())
  return employers;
}

const deleteEmployer = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/employer/deleteemployer/" + id, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
}

const uploadEmployerArbeidsvoorwaarden = async (id, file) => {
  console.log("file", file)
  const formdata = new FormData();
  formdata.append("file", file)
  const Bearer = await getCookie("logintoken")
  const response = await fetch(baseurl + "/employer/upload/" + id, {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
    },
    body: formdata
  });
  return response;
}

// end functions



const login = async (form) => {
  const response = await fetch(baseurl + "/auth", {
    method: "POST",
    body: JSON.stringify({
      Emailaddress: form.email,
      Password: form.password,
    }),
    headers: {
      "Content-type": "application/json",
    }
  });
  return response;


}

const tokencall = async (token) => {
  return await fetch(baseurl + "/auth/" + token, {
    method: "get",
    headers: {
    }
  }).then(res => res.json()).then(body => body);

}

// start functions check-in-at-work
const checkinByHotelId = async (id, nightshift) => {
  console.log(id, nightshift)
  const Bearer = await getCookie("logintoken")
  const type = "work"
  return await fetch(baseurl + "/check/", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      type: type,
      id,
      nightshift: nightshift
    }),
  })
}



const checkin = async (token, { latitude, longitude }) => {
  const type = "work"
  if (latitude && longitude) {
    return await fetch(baseurl + "/check/", {
      method: "POST",
      headers: {
        "Token": "Bearer " + token,
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        type: type,
        cords: {
          latitude,
          longitude
        },
      }),
    })
  }

}
const checkout = async (type, { latitude, longitude }) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/check/checkout", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      type: type,
      cords: {
        latitude,
        longitude
      }
    })
  })
}

const retrieveCheckinData = async (day) => {
  const Bearer = await getCookie("logintoken")
  day = new Date(day).toISOString().slice(0, 10).replace('T', ' ')
  if (Bearer !== "" && Bearer !== null) {
    ////////////////console.log(Bearer)
    return await fetch(baseurl + "/check/day/" + day, {
      method: "GET",
      headers: {
        "Token": "Bearer " + Bearer,
      }
    }).then(response => response.json()).then(result => {
      return result
    });
  }

}

const pause = async ({ latitude, longitude }, checkindata) => {
  //console.log(checkindata)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/check/pausein", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      cords: { latitude, longitude }
    }),
  })
}

const pauseout = async ({ latitude, longitude }) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/check/pauseout", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      cords: { latitude, longitude }
    }),
  })
}

const pauseoutById = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/check/pauseout", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      id
    }),
  })
}

const getCheckinOrOutTime = async () => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/check/inout", {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => response.json()).then(result => {

    return result
  });

}
// end functions check-in-at-work

const myData = async (id = null) => {
  const Bearer = await getCookie("logintoken")
  if (Bearer !== '') {
    return await fetch(baseurl + "/employee/my-data", {
      method: "GET",
      headers: {
        "Token": "Bearer " + Bearer,
        "id": id
      }
    }).then(response => response.json()).then(result => {
      return result
    });
  }

}

const daystats = async () => {

  const Bearer = await getCookie("logintoken")

  return await fetch(baseurl + "/check/daystats", {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => response.json()).then(result => {
    return result
  });


}
// create - edit - get Rooms

const getRooms = async (id) => {
  const Bearer = await getCookie("logintoken")
  const kamers = await fetch(baseurl + "/kamer/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => { return response.json() })
  return kamers;
}

const createroom = async (roomnumer, kamertypid, hotelid) => {

  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/kamer", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({ roomnumer, kamertypid, hotelid }),
  });
}

const createfloor = async (description, hotelid) => {
  ////////////////console.log("floordescriptioninput", description , "hotelid " , hotelid)
  // const Bearer = await getCookie("logintoken")
  // return await fetch(baseurl + "/kamer", {
  //   method: "POST",
  //   headers: {
  //     "Token": "Bearer " + Bearer,
  //     "Content-type": "application/json",
  //   },
  //   body: JSON.stringify({ roomnumer, kamertypid, hotelid, floor }),
  // });
}
const editkamer = async (id, type, hotelid) => {
  ////////////////console.log("id =",id, "type =",type,"hotelid =", hotelid,"floor =", floor)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/kamer/" + id, {
    method: "PUT",
    body: JSON.stringify({
      Type: type,
      hotelid
    }),
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });

}

const deleteRoom = async (id, hotelid) => {
  ////////////////console.log(id, hotelid)

  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/kamer/delete/" + id, {
    method: "POST",
    body: JSON.stringify({
      hotelid
    }),
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
}
// end functions 'Rooms'

// create - edit - get roomtypes


const getRoomsTypes = async (id) => {
  const Bearer = await getCookie("logintoken")
  //////////////////console.log(Bearer)

  const kamertypes = await fetch(baseurl + "/kamerType/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => { return response.json() })
  return kamertypes;
}


const createroomtype = async (roomtypename, hotelid) => {

  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/kamerType", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({ roomtypename, hotelid }),
  });
}

const deleteRoomtype = async (id) => {

  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/kamertype/" + id, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
}

const editkamerType = async (id, name, hotelid) => {

  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/kamerType/" + id, {
    method: "PUT",
    body: JSON.stringify({
      Naam: name,
      hotelid: hotelid
    }),
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
}
// end functions 'roomtypes'


// start functions create - edit - get notifications

const getMyNotifications = async () => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/notification", {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  });

}
const getMyfilteredNotifications = async () => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/notification/mynotifications", {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  });

}

const createnotificationread = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/notification/readnotification/" + id, {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
    }

  })
}

const getMyNotificationCount = async () => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/notification/count", {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  });

}

const uploadEmployeeContract = async (id, file) => {
  console.log("file", file)
  const formdata = new FormData();
  formdata.append("file", file)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/employee/upload/" + id, {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
    },
    body: formdata
  });
}

const getciaw = async (day = new Date()) => {
  day = day = new Date(day).toISOString().slice(0, 10).replace('T', ' ')
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/ciaw/" + day, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }).then(response => response.json().then(body => {
    return body
  }))
}
// create - edit - get GeneralServicestask

const saveGeneralServicestask = async (form) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/generalservicestasks/create", {
    method: "POST",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}
const editGeneralServicestask = async (id, taskDescription, taskDuration, multiple, AD) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtask/" + id, {
    method: "PUT",
    body: JSON.stringify({
      taskDescription: taskDescription,
      taskDuration: taskDuration,
      multiple: multiple,
      AD: AD
    }),
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });

}
const getGeneralServicestasks = async (id) => {
  // const Bearer = await getCookie("logintoken")
  // return await fetch(baseurl + "/generalservicestasks/" + id, {
  //   method: "GET",
  //   headers: {
  //     "Token": "Bearer " + Bearer,
  //   }
  // })
  ////////////console.log("getGeneralServicestasks, " + id)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtask/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  })
}
const deleteGeneralServicestasks = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtask/" + id, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
}

// end GeneralServicestask

// create - edit - get cleaningtasks
const saveCleaningtask = async (form) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtask/create", {
    method: "POST",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}

const getCleaningtasks = async (id = "null", ad = undefined) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtask/tasks/" + id + "/" + ad, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  })
}
const getCleaningADtasks = async (id = "null") => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtask/ad/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  })
}


const editCleaningTask = async (id, taskDescription, taskDuration) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtask/" + id, {
    method: "PUT",
    body: JSON.stringify({
      taskDescription: taskDescription,
      taskDuration: taskDuration
    }),
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });

}
const deleteCleaningTask = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtask/" + id, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
}

const savelinkedTasks = async (id, body) => {
  ////////////////console.log(id, body)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtypes/updateTasks/" + id, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    },
    body: JSON.stringify(body)
  })
}
const getlinkedtasks = async (id) => {
  ////////////////console.log(id)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtypes/linkedtasks/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  })
}

// end cleaningtasks

// create - edit and get cleaningtypes

const saveCleaningtype = async (form) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtypes/create", {
    method: "POST",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}

const getCleaningtypes = async (id) => {
  ////////////////console.log(id)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtypes/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  })
}

const getCleaningtypebyId = async (id) => {
  ////////////////console.log(id)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtypes/byid/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  })
}


const editCleaningType = async (id, description, duration, roomtype_id, type) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtypes/" + id, {
    method: "PUT",
    body: JSON.stringify({
      description: description,
      duration: duration,
      roomtype_id: roomtype_id,
      type: type
    }),
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });

}

const deleteCleaningType = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningtypes/" + id, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });

}
// end cleaning types

// start functions create - edit - delete cleaningassignments

const saveCleaningassignment = async (form) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningassignments/create", {
    method: "POST",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}

const updateCleaningassignment = async (form, id) => {
  const Bearer = await getCookie("logintoken")
  delete form.id;
  delete form.type;
  delete form.achternaam;
  delete form.voornaam;
  delete form.kamerType
  delete form.creationdate
  return await fetch(baseurl + "/cleaningassignments/" + id, {
    method: "PUT",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}

const deleteCleaningassignment = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/cleaningassignments/" + id, {
    method: "DELETE",
    // body: JSON.stringify({
    //   ...form
    // }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}

// gets all the cleaningassignments for current day
const getCleaningassignments = async (hotel_id) => {
  const Bearer = getCookie("logintoken")
  return await fetch(baseurl + "/cleaningassignments/" + hotel_id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}

const getsupervisorcleaningassignments = async () => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments", {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }
  )
}

const getsupervisorcleaningassignmentsfordate = async (date) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/" + date, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }
  )
}


const getAllHotelData = async (date, hotelid) => {
  //////console.log("getAllHotelData ", hotelid)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/getallhoteldata/" + date + "/" + hotelid, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }
  )
}

const getmycleaningassignments = async () => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/myassignments", {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }
  )
}

const dndassigment = async (id, time, dnddescription) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/updateassignmentstatus/" + id, {
    method: "PUT",
    body: JSON.stringify({
      status: 6,
      dndTime: time,
      DNDRemark: dnddescription
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const startRecleanassigment = async (id, time) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/updateassignmentstatus/" + id, {
    method: "PUT",
    body: JSON.stringify({
      status: 7,
      startTimeReclean: time,
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const ReportIssueassigment = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/updateassignmentstatus/" + id, {
    method: "PUT",
    body: JSON.stringify({
      status: 4,
      HasIssues: 1
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const startassigment = async (id, time) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/updateassignmentstatus/" + id, {
    method: "PUT",
    body: JSON.stringify({
      status: 1,
      startTime: time,
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const stopassigment = async (id, time, status) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/updateassignmentstatus/" + id, {
    method: "PUT",
    body: JSON.stringify({
      status: status,
      stopTime: time,
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const stopRecleanassigment = async (id, time, status) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/updateassignmentstatus/" + id, {
    method: "PUT",
    body: JSON.stringify({
      status: status,
      stopTimeReclean: time,
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const assigmentQualityControled = async (id, statusvalue) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/updateassignmentstatus/" + id, {
    method: "PUT",
    body: JSON.stringify({
      status: statusvalue,
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const reportassigmentissue = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/cleaningassignments/updateassignmentstatus/" + id, {
    method: "PUT",
    body: JSON.stringify({
      status: 4,
      HasIssues: 1
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

// end cleaningassignments


// this function checks the version running on the client against the version deployed on the server.
// if different the clientversion is updated
const getversion = async () => {
  return await fetch(baseurl + "/check/version", {
    method: "GET",
    headers: {

    }
  }).then(res => res.json())
}

const sendPassReset = async (email) => {
  return await fetch(baseurl + "/password/reset-link", {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      email
    })
  })
}

const resetpassword = async (token, password) => {
  const response = await fetch(baseurl + "/password/reset", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token, password }),
  });
  return response;
}

const updateIDcard = async (file, id, ingangsdatum, afloopdatum) => {
  const Bearer = await getCookie("logintoken")
  if (file !== null) {
    return await fetch(
      baseurl + "/idcard/upload/" + id, {
      method: "post",
      body: JSON.stringify({
        idcard: file,
        ingangsdatum_id: ingangsdatum,
        afloopdatum_id: afloopdatum
      }),
      headers: {
        "Token": "Bearer " + Bearer,
        "Content-type": "application/json",
      }
    }
    )
  } else {
    return await fetch(
      baseurl + "/idcard/upload/" + id, {
      method: "post",
      body: JSON.stringify({
        ingangsdatum,
        afloopdatum
      }),
      headers: {
        "Token": "Bearer " + Bearer,
        "Content-type": "application/json",
      }
    }
    )

  }

}
const getIDcard = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/idcard/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  }
  )

}
// start rooster

const saveRooster = async (id, form) => {
  ////////////////console.log(id, form)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/rooster/" + id, {
    method: "POST",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const approveRooster = async (id, date = null, approved) => {
  if (date === null) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    date = tomorrow.toLocaleDateString("en-CA");
  }
  console.log(id, date, approved)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/rooster/approve/" + id + "/" + date + "/" + approved, {
    method: "put",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}


const updateRooster = async (id, form, date = null, approved) => {
  if (date === null) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    date = tomorrow.toLocaleDateString("en-CA");
  }
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/rooster/" + id + "/" + date + "/" + approved, {
    method: "put",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const getnextdayemprooster = async (empid, hotelid, datum) => {
  ////////////////console.log(empid, hotelid, datum)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/rooster/nextday/" + empid + "/" + hotelid + "/" + datum, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  }
  )
}

const insertemployeetorooster = async (hotelid, userid, datum) => {
  // console.log("datum : ", datum)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/rooster/emp/" + hotelid, {
    method: "PUT",
    body: JSON.stringify({
      hotel_Id: hotelid,
      werknemer_Id: userid,
      blijver: 0,
      vertrekker: 0,
      AD: 0,
      planned: true,
      approved: true,
      creatiedag: datum.toLocaleDateString("en-CA")
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}
const updateemployeetorooster = async (hotelid, userid, datum) => {
  // console.log("datum : ", datum)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/rooster/emp/" + hotelid, {
    method: "PUT",
    body: JSON.stringify({
      hotel_Id: hotelid,
      werknemer_Id: userid,
      blijver: 0,
      vertrekker: 0,
      AD: 0,
      planned: true,
      approved: true,
      creatiedag: datum.toLocaleDateString("en-CA")
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const addemployeetorooster = async (hotelid, userid, datum) => {
  ////////////////console.log(id, form)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/rooster/emp/" + hotelid, {
    method: "POST",
    body: JSON.stringify({
      hotel_Id: hotelid,
      werknemer_Id: userid,
      blijver: 1,
      vertrekker: 1,
      AD: 1,
      creatiedag: datum.toLocaleDateString("en-CA")
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

// end rooster

const editFloor = async (id, description) => {
  const Bearer = await getCookie("logintoken")
  // return await fetch(
  //   baseurl + "/idcard/" + id, {
  //   method: "GET",
  //   headers: {
  //     "Token": "Bearer " + Bearer,
  //   }
  // }
  // )

}

const deleteFloor = async (id, hotelid) => {
  ////////////////console.log(id, hotelid)

  const Bearer = await getCookie("logintoken")
  // return await fetch(baseurl + "/kamer/delete/" + id, {
  //   method: "POST",
  //   body: JSON.stringify({
  //     hotelid
  //   }),
  //   headers: {
  //     "Content-type": "application/json",
  //     "Token": "Bearer " + Bearer,
  //   }
  // });
}
const getvariabletable = async (tablename) => {
  ////////////////console.log(empid, hotelid)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/variabletable/" + tablename, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  }
  )
}



const savetotalplanned = async (hotel_Id, form, date = null) => {

  if (date === null) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    date = tomorrow.toLocaleDateString("en-CA");
  }
  //////////console.log(form)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/rooster/totalplanned/" + hotel_Id + "/" + date, {
    method: "put",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}


const getnexttotalplanned = async (hotel_Id, datum = null) => {
  if (datum === null) {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    datum = tomorrow
  }
  datum = new Date(datum).toLocaleDateString("en-CA");
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/rooster/totalplanned/" + hotel_Id + "/" + datum, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  }
  )
}
// start verlofaanvragen

const gettotalplanned = async (hotel_Id, roosterday) => {
  if (roosterday === undefined) {
    let currentDate = new Date()
    roosterday = currentDate.toLocaleDateString("en-CA");
  }
  ////console.log("roosterday: ", roosterday)
  ////console.log("hotel_Id: ", hotel_Id)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/rooster/totalplanned/" + hotel_Id + "/" + roosterday, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  }
  )
}


const getholidaysbyid = async (id) => {
  const Bearer = await getCookie("logintoken")

  //////////////console.log(Bearer)
  return await fetch(
    baseurl + "/verlofregister/holidayrequests/" + id, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  }
  )
}


const getverlofaanvragen_metstatus = async (status) => {

  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/verlofregister/getAllFromStatus/" + status, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  })
}

const getverlofaanvragen = async () => {

  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/verlofregister/getAll", {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  })
}
const getverlofaanvragenvoorwerknemer = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/verlofregister/holidayrequests/" + id, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  })
}

const getverlofaanvragenhotel_data = async (hotelid, datum_begin, datum_eind) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/verlofregister/holidayshotel/" + hotelid + "/" + datum_begin + "/" + datum_eind, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  })
}

const saveverlofaanvraag = async (form, id) => {
  console.log(form, id)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/verlofregister/", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      ...form,
      "werknemers_Id": id
    })
  })
}

const changeholidaystatus = async (form, id) => {
  //////////////console.log(form, id)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/verlofregister/changeRequestStatus/" + id, {
    method: "PUT",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}

const updateHolidayRequest = async (id, form) => {
  //////////////console.log(id, "  " , form)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/verlofregister/holidayrequest/" + id, {
    method: "PUT",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}


// end verlofaanvragen

// strat regios

const createregion = async (regiondescription, regionname) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/regio/", {
    method: "POST",
    body: JSON.stringify({
      description: regiondescription,
      name: regionname
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}
const updateregion = async (id, regiondescription, regionname) => {

  //////////////console.log(id, regiondescription, regionname)
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/regio/" + id, {
    method: "PUT",
    body: JSON.stringify({
      description: regiondescription,
      name: regionname
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}
const deleteregion = async (id) => {

  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/regio/" + id, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
}

const gethotelregions = async (regionid) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/hotelregiolink/gethotelregios/" + regionid, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  })
}

const getregionhotels = async (hotelid) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/hotelregiolink/getregiohotels/" + hotelid, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  })
}

const linkhoteltoregion = async (hotelid, regionid) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/hotelregiolink/", {
    method: "POST",
    body: JSON.stringify({
      region_id: regionid,
      hotel_id: hotelid
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}
const unlinkhoteltoregion = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/hotelregiolink/" + id, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
}
//end regio's


const createIssue = async (cleaningassignment_Id, picture, description) => {
  //////////////console.log(cleaningassignment_Id, picture, description)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/comment/issue", {
    method: "post",
    body: JSON.stringify({
      cleaningassignment_Id,
      picture,
      description
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}

const getIssuefromCleaningAssignment = async (id) => {
  ////////////////console.log(id)

  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/comment/issue/" + id, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  }
  )
}


//holidayrequestsbyid

const savehotelsupervisors = async (id, hotels) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/employee/supervisor/" + id, {
    method: "POST",
    body: JSON.stringify({
      hotels
    }),
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })

}
const getsupervisedhotels = async (id) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/employee/supervisor/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer
    }
  })
}

const getregions = async () => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/regio/", {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer
    }
  })
}
const updateIssue = async (id, form) => {
  ////////////console.log(id, ":", form)
  form = formatdates(form)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/comment/issue/" + id, {
    method: "put",
    body: JSON.stringify({
      ...form
    }),
    headers: {
      "Content-type": "application/json",
      "Token": "Bearer " + Bearer,
    }
  });
}

const getView = async (viewname, filterfield, filtervalue) => {
  //console.log("filterfield: ", filtervalue)
  const Bearer = await getCookie("logintoken")
  return await fetch(
    baseurl + "/views/" + viewname + "/" + filterfield + "/" + filtervalue, {
    method: "get",
    headers: {
      "Token": "Bearer " + Bearer
    }
  })
}





const triggermails = async () => {
  const Bearer = await getCookie("logintoken")
  const date = new Date().toLocaleDateString("en-CA");
  return await fetch(baseurl + "/rooster/mails/" + date, {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    }
  })
}
const triggerEmployeePerformanceReport = async (email, nr_wkn, startDate, endDate) => {
  const Bearer = await getCookie("logintoken")
  const returnedData = await fetch(baseurl + "/reports/avg-assignment-duration", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      email,
      nr_wkn,
      startDate,
      endDate,
    })
  })
  console.log("returnedData", returnedData)
  return returnedData
}

const triggerExpiredIdCardReport = async (email, employer, days, requestedby) => {
  const Bearer = await getCookie("logintoken")
  const returnedData = await fetch(baseurl + "/reports/id-expiration", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      days,
      email,
      employer
    })
  })
  console.log("returnedData", returnedData)
  return returnedData
}
const triggerEmployeeProductivityReport = async (email, hotel_id, assignee_Id, startDate, endDate, requestedby) => {
  console.log("triggerEmployeeProductivityReport", email, " empl:", assignee_Id, " hotel:", hotel_id, "dates: ", startDate, endDate, requestedby)
  const Bearer = await getCookie("logintoken")
  const returnedData = await fetch(baseurl + "/reports/employee-productivity", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      email: email,
      assignee_Id,
      hotel_id,
      startDate,
      endDate,
      requestedby
    })
  })
  //console.log("returnedData" , returnedData)
  return returnedData
}

const triggerExpiredContractReport = async (email, employer, days, requestedby) => {
  console.log(employer)
  const Bearer = await getCookie("logintoken")
  const returnedData = await fetch(baseurl + "/reports/contract-expiration", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      days,
      email,
      employer
    })
  })
  return returnedData
}

const triggerBirthdayReport = async (email, days) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/reports/birthday", {
    method: "POST",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      days,
      email
    })
  })
}


const updateemployeetoroosterv2 = async (emp) => {
  const Bearer = await getCookie("logintoken")
  return await fetch(baseurl + "/rooster/empv2", {
    method: "PUT",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      ...emp
    })
  })
}

// focusoftheday
// const savefocusoftheday = async (hotel_id, description, date) => {
//   //////////console.log(hotel_id, description, date)
//   const Bearer = await getCookie("logintoken")
//   return await fetch(
//     baseurl + "/focusoftheday/", {
//     method: "POST",
//     headers: {
//       "Token": "Bearer " + Bearer,
//       "Content-type": "application/json",
//     },
//     body: JSON.stringify(
//       {
//         "hotel_id": hotel_id,
//         "description": description,
//         "date": date
//       })
//   })
// }

const sendEmailMessage = async (from, to, employer, subject, message, id) => {
  const Bearer = await getCookie("logintoken")
console.log("cccccccccccc", new Date().toLocaleString())
  const returnobject = await fetch(baseurl + "/sendmessages/send", {
    method: "PUT",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      id,
      from,
      to,
      employer,
      subject,
      message,
      send:true,
      senddate:new Date()
    })
  })
  //console.log("ffffffffffff" , returnobject)
  return returnobject
}


const saveEmailMessage = async (from, to, employer, subject, message) => {
  const Bearer = await getCookie("logintoken")
  const returnobject = await fetch(baseurl + "/sendmessages/save", {
    method: "PUT",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      from,
      to,
      employer,
      subject,
      message
    })
  })
  console.log("fffffffffffff", returnobject)
  return returnobject
}

const updateEmailMessage = async (from, to, employer, subject, message, id) => {
  const Bearer = await getCookie("logintoken")
  const returnobject = await fetch(baseurl + "/sendmessages/update/"+ id, {
    method: "PUT",
    headers: {
      "Token": "Bearer " + Bearer,
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      from,
      to,
      employer,
      subject,
      message
    })
  })
  console.log("fffffffffffff", returnobject)
  return returnobject
}

const getAllEmailMessages = async (send, all) => {
  const Bearer = await getCookie("logintoken")
  const messages = await fetch(baseurl + "/sendmessages/getall/" + send +"/"+ all, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  })
  return messages;

  // .then(response => response.json()).then(result => {
  //   return result
  // })
}

const getEmailMessage = async (id) => {
  const Bearer = await getCookie("logintoken")
  const message = await fetch(baseurl + "/sendmessages/get/" + id, {
    method: "GET",
    headers: {
      "Token": "Bearer " + Bearer,
    }
  })
  console.log(message)
  return message;

  // .then(response => response.json()).then(result => {
  //   return result
  // })
}



export {
  saveEmailMessage, getAllEmailMessages,getEmailMessage,updateEmailMessage,sendEmailMessage,
  getemployers, deleteEmployer, getEmployer,
  createEmployer, UpdateEmployer, uploadEmployerArbeidsvoorwaarden,
  approveRooster, isNightshift,
  savehotelsupervisors,
  updateemployeetoroosterv2,
  getfilestoragelocation,
  getsupervisedhotels,
  sendhoteldata, getallhotels, gethotel,
  getcontract, sendemployeedata, getemployees, deleteEmployee,
  login, tokencall, checkin,
  retrieveCheckinData, checkout, getCheckinOrOutTime,
  pause, myData, daystats,
  updateHotelData, getRooms, getRoomsTypes,
  getserverurl, createroom, createroomtype,
  editkamer, deleteRoom, deleteRoomtype, updateEmployeedata,
  editkamerType, getMyNotifications, getMyNotificationCount,
  uploadEmployeeContract, getciaw, pauseout,
  saveLinkedhotels, getLinkedhotels, checkinByHotelId,
  pauseoutById, saveCleaningtask, getCleaningtasks, editCleaningTask, deleteCleaningTask, dndassigment,
  saveCleaningtype, getCleaningtypes, editCleaningType, deleteCleaningType, saveCleaningassignment,
  getCleaningassignments, updateCleaningassignment, deleteCleaningassignment, getsupervisorcleaningassignmentsfordate,
  getversion, sendPassReset, savelinkedTasks, getlinkedtasks, getMyLinkedhotels, gethotelcleaners,
  getsupervisorcleaningassignments, getmycleaningassignments, startassigment, stopassigment, reportassigmentissue, assigmentQualityControled,
  resetpassword, getMyfilteredNotifications, createnotificationread, updateIDcard,
  getIDcard, saveRooster, getnextdayemprooster, createfloor, createregion, getvariabletable, editFloor, deleteFloor,
  updateRooster, getholidaysbyid, savetotalplanned, getnexttotalplanned, gettotalplanned, getverlofaanvragen, createIssue, getIssuefromCleaningAssignment, addemployeetorooster, updateemployeetorooster, changeholidaystatus, updateHolidayRequest,
  getverlofaanvragenvoorwerknemer, saveverlofaanvraag, getverlofaanvragenhotel_data, getverlofaanvragen_metstatus, updateregion, deleteregion, gethotelregions, linkhoteltoregion, getregionhotels, unlinkhoteltoregion,
  getGeneralServicestasks, saveGeneralServicestask, deleteGeneralServicestasks, editGeneralServicestask, getregions, updateIssue, getCleaningADtasks, getView,
  getCleaningtypebyId, getLinkedhotelscoords, getallstatushotels, triggermails, triggerEmployeePerformanceReport, triggerExpiredIdCardReport, triggerExpiredContractReport,
  triggerBirthdayReport, savefocusoftheday, startRecleanassigment, stopRecleanassigment, ReportIssueassigment, gethistoricalhotelcleaners, getAllhotelsForAdministrator, getAllHotelData, insertemployeetorooster,
  triggerEmployeeProductivityReport
}
